const excludedPaths = [
  '/shop/orderstatus',
  '/shop/kvitto',
  '/shop/avtalssammanfattning',
];

export default defineNuxtRouteMiddleware((to) => {
  if (import.meta.server) {
    return;
  }

  const redirectUrl = 'https://www.halebop.se';

  const excludedPathsRegex = new RegExp(
    `^(?:${excludedPaths
      .map((path) => path.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
      .join('|')})(?:\\/.*)?$`,
  );

  if (excludedPathsRegex.test(to.path)) {
    return;
  }

  return navigateTo(redirectUrl, {
    external: true,
  });
});
